import { dateTimeFormat, formatToRunningCase } from "src/utils";
import styles from "./Entitlement.module.scss";
import { EMPTY_STRING } from "src/components/constant/constant";
import { Entitlement } from "./entitlementSlice";
import { entitlementStatusColors } from "src/variable/randomColor";

const columns = (onEdit?: (_entitlement: Entitlement) => void) => {
  return [
    {
      title: "Id",
      dataIndex: "entitlement_id",
      key: "entitlement_id"
    },
    {
      title: "Organisation Id",
      dataIndex: "organisation_id",
      key: "organisation_id"
    },
    {
      title: "Object Type",
      dataIndex: "object_type",
      key: "object_type"
    },
    {
      title: "Object Id",
      dataIndex: "object_id",
      key: "object_id"
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: string) => {
        const statusColor = entitlementStatusColors[status] || entitlementStatusColors.INACTIVE;

        return (
          <div className={styles.tableStatus}>
            <div
              className={styles.statusBadge}
              style={{ backgroundColor: statusColor.background, color: statusColor.color }}
            >
              {formatToRunningCase(status)}
            </div>
          </div>
        );
      }
    },
    {
      title: "Operated By",
      dataIndex: "operated_by",
      key: "operated_by",
      render: (operated_by: string) => <div>{operated_by}</div>
    },
    {
      title: "Valid From",
      dataIndex: "valid_from",
      key: "valid_from",
      render: (valid_from: string) => <div>{dateTimeFormat(valid_from).date}</div>
    },
    {
      title: "Valid Until",
      dataIndex: "valid_untill",
      key: "valid_untill",
      render: (valid_untill: string) => <div>{dateTimeFormat(valid_untill).date}</div>
    },
    {
      title: EMPTY_STRING,
      dataIndex: EMPTY_STRING,
      key: "operations",
      render: (_text: string, record: Entitlement) => {
        if (record.operated_by !== "MANUAL") {
          return null;
        }

        return (
          <div onClick={() => onEdit?.(record)} className={styles.operation} style={{ cursor: "pointer" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d="M8.88541 3.05214L10.9478 5.11453M9.76042 2.17714C10.3299 1.60762 11.2533 1.60762 11.8228 2.17714C12.3924 2.74665 12.3924 3.67002 11.8228 4.23953L3.79167 12.2707H1.75V10.1876L9.76042 2.17714Z"
                stroke="#64748B"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        );
      }
    }
  ];
};

export default columns;
